import { getLibraryContentUrl } from "../Helpers"
import ProtectedContent from "../components/ProtectedContent"


export default function VideoAccess({ data, watermark }) {
  return (
    <div className="library-video-access">
      <ProtectedContent watermark={watermark}>
        <video
          controls
          controlsList="nodownload noremoteplayback"
          disablePictureInPicture
          disableRemotePlayback
          onContextMenu={(event) => event.preventDefault()}
          onDragStart={(event) => event.preventDefault()}
          playsInline
          preload="metadata"
        >
          <source src={getLibraryContentUrl(data.fileAccessToken)} />
          Your browser does not support video playback.
        </video>
      </ProtectedContent>
    </div>
  )
}
